import { useContext } from "react";

import { Tr069DeviceContext } from "../contexts/Tr069DeviceContext";

const useTr069Device = () => {
  const context = useContext(Tr069DeviceContext);

  if (!context) throw new Error("Tr069DeviceContext must be placed within Tr069DeviceProvider");

  return context;
};

export default useTr069Device;
